import { render, staticRenderFns } from "./StaffField.vue?vue&type=template&id=22245e0d&scoped=true"
import script from "./StaffField.vue?vue&type=script&lang=ts"
export * from "./StaffField.vue?vue&type=script&lang=ts"
import style0 from "./StaffField.vue?vue&type=style&index=0&id=22245e0d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22245e0d",
  null
  
)

export default component.exports